/**
 * Ryan O'Dowd
 * 2025-05-11
 * © Copyright 2025 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import Icon from '@react-native-vector-icons/material-design-icons';
import React from 'react';
import Text from '@components/common/Text';
import {
  TouchableOpacity,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const AuthButton = (props: AuthButtonProps) => {
  const styles = hooks.useStyles(getStyles);
  const i18n = hooks.useI18n(props.localeId);

  return (
    <TouchableOpacity
      style={[styles.container, props.authIsPending ? styles.disabledContainer : null]}
      onPress={() => {
        props.setAuthIsPending(true);
        props.onPress();
      }}
      disabled={props.authIsPending}
    >
      <Icon style={styles.authProviderIcon} name={props.iconName} />
      <Text style={styles.buttonText}>{`${props.isLinking ? i18n('linkWith') : i18n('signInWith')} ${props.providerName}`}</Text>
    </TouchableOpacity>
  );
};

class AuthButtonProps {
  iconName: 'apple' | 'google' | 'email';
  providerName: 'Apple' | 'Google' | 'Email';
  localeId: any;
  onPress: () => void;
  setAuthIsPending: (authIsPending: boolean) => void;

  authIsPending?: boolean;
  isLinking?: boolean;
};

export default AuthButton;
